import { render, staticRenderFns } from "./ValidationAlertComponent.vue?vue&type=template&id=c4788252&"
import script from "./ValidationAlertComponent.vue?vue&type=script&lang=js&"
export * from "./ValidationAlertComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports